import React, { useState } from 'react';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
import { MailIcon, ClockIcon, CheckCircleIcon } from 'lucide-react';
export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    preferredContact: 'email'
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
    setSubmitted(true);
    // Reset form after 3 seconds
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: '',
        preferredContact: 'email'
      });
    }, 3000);
  };
  return <div className="w-full" data-id="element-167">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-white to-light-grey py-16" data-id="element-168">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-169">
          <h1 className="text-4xl md:text-5xl font-bold text-navy font-heading mb-6" data-id="element-170">
            Get in Touch
          </h1>
          <p className="text-xl text-dark" data-id="element-171">
            Need help setting up reminders or managing your plan? We are here to
            help.
          </p>
        </div>
      </section>
      {/* Contact Information & Form */}
      <section className="py-16 bg-white" data-id="element-172">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-174">
            {/* Contact Information */}
            <div data-id="element-175">
              <h2 className="text-3xl font-bold text-navy font-heading mb-6" data-id="element-176">
                Contact Information
              </h2>
              <p className="text-dark mb-8" data-id="element-177">
                Our team is available to answer your questions and help you get
                started with Artisanfix.
              </p>
              <div className="space-y-6 mb-8" data-id="element-178">
                <Card className="hover:shadow-lg transition-shadow" data-id="element-179">
                  <div className="flex items-start" data-id="element-180">
                    <div className="flex-shrink-0" data-id="element-181">
                      <div className="rounded-full bg-light-grey p-3 w-12 h-12 flex items-center justify-center" data-id="element-182">
                        <MailIcon className="h-6 w-6 text-navy" data-id="element-183" />
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-184">
                      <h3 className="text-lg font-bold text-navy mb-2" data-id="element-185">
                        Email Us
                      </h3>
                      <a href="mailto:bhagatjenith3@gmail.com" className="text-sky-blue hover:underline" data-id="element-186">
                        bhagatjenith3@gmail.com
                      </a>
                    </div>
                  </div>
                </Card>
                <Card className="hover:shadow-lg transition-shadow" data-id="element-187">
                  <div className="flex items-start" data-id="element-188">
                    <div className="flex-shrink-0" data-id="element-189">
                      <div className="rounded-full bg-light-grey p-3 w-12 h-12 flex items-center justify-center" data-id="element-190">
                        <ClockIcon className="h-6 w-6 text-navy" data-id="element-191" />
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-192">
                      <h3 className="text-lg font-bold text-navy mb-2" data-id="element-193">
                        Response Time
                      </h3>
                      <p className="text-dark" data-id="element-194">
                        We aim to respond to all enquiries within 24 hours on
                        weekdays.
                      </p>
                    </div>
                  </div>
                </Card>
              </div>
              <div className="bg-light-grey rounded-lg p-6" data-id="element-195">
                <h3 className="text-lg font-bold text-navy mb-3" data-id="element-196">
                  What You Can Expect
                </h3>
                <ul className="space-y-2" data-id="element-197">
                  <li className="flex items-start" data-id="element-198">
                    <CheckCircleIcon className="h-5 w-5 text-sky-blue mr-2 flex-shrink-0 mt-0.5" data-id="element-199" />
                    <span className="text-dark" data-id="element-200">
                      Friendly, helpful support from our UK-based team
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-201">
                    <CheckCircleIcon className="h-5 w-5 text-sky-blue mr-2 flex-shrink-0 mt-0.5" data-id="element-202" />
                    <span className="text-dark" data-id="element-203">
                      Clear answers to your questions
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-204">
                    <CheckCircleIcon className="h-5 w-5 text-sky-blue mr-2 flex-shrink-0 mt-0.5" data-id="element-205" />
                    <span className="text-dark" data-id="element-206">
                      Assistance with setup and onboarding
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-207">
                    <CheckCircleIcon className="h-5 w-5 text-sky-blue mr-2 flex-shrink-0 mt-0.5" data-id="element-208" />
                    <span className="text-dark" data-id="element-209">
                      Guidance on choosing the right plan
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Contact Form */}
            <div data-id="element-210">
              <Card data-id="element-211">
                <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-212">
                  Send Us a Message
                </h2>
                {submitted ? <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center" data-id="element-213">
                    <CheckCircleIcon className="h-12 w-12 text-green-500 mx-auto mb-4" data-id="element-214" />
                    <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-215">
                      Message Sent!
                    </h3>
                    <p className="text-green-700" data-id="element-216">
                      Thank you for contacting us. We will get back to you
                      within 24 hours on weekdays.
                    </p>
                  </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-217">
                    <div data-id="element-218">
                      <label htmlFor="name" className="block text-sm font-medium text-navy mb-2" data-id="element-219">
                        Name <span className="text-red-500" data-id="element-220">*</span>
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-light-grey rounded-md focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent" placeholder="Your full name" data-id="element-221" />
                    </div>
                    <div data-id="element-222">
                      <label htmlFor="email" className="block text-sm font-medium text-navy mb-2" data-id="element-223">
                        Email <span className="text-red-500" data-id="element-224">*</span>
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-light-grey rounded-md focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent" placeholder="your.email@example.com" data-id="element-225" />
                    </div>
                    <div data-id="element-226">
                      <label htmlFor="phone" className="block text-sm font-medium text-navy mb-2" data-id="element-227">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-light-grey rounded-md focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent" placeholder="Optional" data-id="element-228" />
                    </div>
                    <div data-id="element-229">
                      <label htmlFor="preferredContact" className="block text-sm font-medium text-navy mb-2" data-id="element-230">
                        Preferred Contact Method{' '}
                        <span className="text-red-500" data-id="element-231">*</span>
                      </label>
                      <select id="preferredContact" name="preferredContact" value={formData.preferredContact} onChange={handleChange} required className="w-full px-4 py-2 border border-light-grey rounded-md focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent" data-id="element-232">
                        <option value="email" data-id="element-233">Email</option>
                        <option value="phone" data-id="element-234">Phone</option>
                        <option value="either" data-id="element-235">Either</option>
                      </select>
                    </div>
                    <div data-id="element-236">
                      <label htmlFor="message" className="block text-sm font-medium text-navy mb-2" data-id="element-237">
                        Message <span className="text-red-500" data-id="element-238">*</span>
                      </label>
                      <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-2 border border-light-grey rounded-md focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent resize-none" placeholder="How can we help you?" data-id="element-239" />
                    </div>
                    <Button type="submit" size="lg" className="w-full" data-id="element-240">
                      Send Message
                    </Button>
                    <p className="text-sm text-dark/60 text-center" data-id="element-241">
                      We aim to respond within 24 hours on weekdays.
                    </p>
                  </form>}
              </Card>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Link */}
      <section className="py-16 bg-light-grey" data-id="element-242">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-243">
          <h2 className="text-3xl font-bold text-navy font-heading mb-4" data-id="element-244">
            Looking for Quick Answers?
          </h2>
          <p className="text-lg text-dark mb-8" data-id="element-245">
            Check out our FAQs for answers to common questions.
          </p>
          <Button size="lg" href="/faq" variant="outline" data-id="element-246">
            View FAQs
          </Button>
        </div>
      </section>
    </div>;
}